import cn from 'classnames';
import React from 'react';

import { Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import styles from './styles.module.scss';

const { Heading } = Typography;

type Props = {
    heading: string;
    subHeading: string;
};

export const MobilePageHeadingB = ({ heading, subHeading }: Props) => {
    const [isVisible, setIsVisible] = useBoolean(false);

    return (
        <div className={styles.header}>
            <Heading level={1}>{heading}</Heading>
            <div onClick={setIsVisible.toggle} className={styles.subHeading}>
                <div className={cn(styles.text, { [styles.hidden]: !isVisible })}>{subHeading}</div>
                {!isVisible && (
                    <div className={styles.readMore}>
                        <span className={styles.toggle}>Ещё</span>
                    </div>
                )}
            </div>
        </div>
    );
};
